import { render } from "./MenuArrow.vue?vue&type=template&id=db750ec0"
import script from "./MenuArrow.vue?vue&type=script&lang=js"
export * from "./MenuArrow.vue?vue&type=script&lang=js"

import "./MenuArrow.vue?vue&type=style&index=0&id=db750ec0&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.3.4+webpack@5.87.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__